export default __webpack_public_path__ + "icon-mail-46b8c901c576864f48ed4734413bab95.svg";